<template>
  <div class="container-fluid mb-10 comments-container pt-4">
    <form action="#" @submit.prevent="addComment" method="post">
      <div class="form-group">
        <textarea
          class="form-control"
          v-model="commentText"
          rows="7"
          cols="3"
          required
          placeholder="Type your comment..."
          maxlength="200"
        ></textarea>
      </div>
      <div class="form-group">
        <button class="btn btn-primary btn-sm fs-12 w-100 btn--base bases">
          Add Comment
        </button>
      </div>
    </form>
    <div class="comments-list">
      <div class="comments">
        <div class="comment" v-for="comment in comments" :key="comment.id">
          <img
            src="/images/vue/image/avatar.jpeg"
            alt=""
            class="comment__image"
          />
          <div class="comment__commentator">
            {{ comment.commentator.firstname }}
            {{ comment.commentator.lastname }} {{ " • " }}
          </div>
          <div class="comment__time">
            {{ diffForHumans(comment.created_at) }}
          </div>
          <div class="break"></div>
          <div class="comment__comment">{{ comment.comment }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import axios from "axios";

TimeAgo.addDefaultLocale(en);
export default {
  name: "comments",
  props: {
    itemId: { 
      type: Number|String,
      required: false 
    },
    auth: { 
      type: Boolean|Number, 
      required: false 
    },
    is_episode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      commentText: "",
      comments: [],
      // itemId: this.itemId,
    };
  },
  methods: {
    async getComments() {
      try {
        this.$Progress.start();
        if (this.is_episode) {
          const res = await axios.get(`/episode/${this.itemId}/comments`);
          this.comments = res.data.comments;
          this.$Progress.finish();
          return;
        }
        if (this.is_ablum) {
          const res = await axios.get(`/album-item/${this.itemId}/comments`);
          this.comments = res.data.comments;
          this.$Progress.finish();
          return;
        }
        const res = await axios.get(`/item/${this.itemId}/comments`);
        this.comments = res.data.comments;
        this.$Progress.finish();
      } catch (e) {
        this.$Progress.fail();
        notify(
          "error",
          "Something went wrong, please check your Internet and try again."
        );
        console.log(e);
      }
    },
    diffForHumans(date) {
      const timeAgo = new TimeAgo("en-US");
      return timeAgo.format(new Date(date));
    },
    async addComment() {
      if (!this.auth) {
        notify("error", "You need to login first");
        return;
      }
      try {
        this.$Progress.start();
        if (this.is_episode) {
          const res = await axios.post(`/episode/${this.itemId}/comment`, {
            comment: this.commentText,
          });
          this.commentText = "";
          this.comments.unshift(res.data.commentObj);
          this.$Progress.finish();
          return;
        }

        const res = await axios.post(`/item/${this.itemId}/comment`, {
          comment: this.commentText,
        });
        this.commentText = "";
        this.comments.unshift(res.data.commentObj);
        this.$Progress.finish();
      } catch (e) {
        notify("error", "Something went wrong");
        this.$Progress.fail();
        console.log(e);
      }
    },
  },
  created() {
    setTimeout(() => {
      this.getComments();
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.comments-container {
  background-color: var(--color-secondary);
  border-radius: 6px;
  padding: 10px 30px;
  margin-bottom: 40px;
  // max-height: 40rem;
  // overflow-y: auto;
  @media screen and (max-width: 900px) {
    & {
      padding: 5px 10px;
      margin-bottom: 20px;
    }
  }

  @media screen and (max-width: 480px) {
    .movie-section {
      padding: 2px 10px;
    }
  }
}

.break {
  flex-basis: 100%;
  height: 0;
}

.comments {
  margin-top: 15px;
  // max-height: 80vh;
  // overflow: auto;
  @media screen and (max-width: 900px) {
    & {
      margin-top: 10px;
    }
  }
  @media screen and (max-width: 480px) {
    & {
      margin-top: 5px;
    }
  }

  .comment {
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #2d3a4a;
    @media screen and (max-width: 900px) {
      & {
        padding: 5px;
      }
    }
    @media screen and (max-width: 480px) {
      & {
        padding: 2px;
      }
    }

    &__image {
      border-radius: 50%;
      width: 30px;
      margin-right: 10px;
      @media screen and (max-width: 900px) {
        & {
          width: 20px;
        }
      }
    }

    &__commentator {
      font-weight: bold;
      letter-spacing: 1px;
      font-size: 13px;
      color: white;
      margin-right: 10px;
      @media screen and (max-width: 900px) {
        & {
          font-size: 11px;
        }
      }
    }

    &__comment {
      font-size: 14px;
      margin-top: 10px;
      letter-spacing: 1px;

      @media screen and (max-width: 900px) {
        & {
          font-size: 12px;
        }
      }
    }

    &__time {
      font-size: 13px;
      letter-spacing: 1px;
      color: #9297a6;
      margin-left: 20px;
      text-transform: uppercase;
    }
  }
}

.form-control {
  background-color: var(--color-primary);
  color: white;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #2d3a4a;
}

.btn-primary {
  border-radius: 6px;
}
.bases{
  background-color: #2a2a2a !important;
    border: 1px solid #2a2a2a !important;
}
.bases:hover{
  background-color: var(--bg-hover-color) !important;
    border: 1px solid #2a2a2a !important;
    box-shadow: 0 10px 20px transparent !important;
}
</style>
